import React from "react";
import { FC } from "react";
import { t } from "@helpers/translate";

import {
  PostCategoriesQuery,
  PostCategoriesQueryVariables,
} from "@graphql/types";
import Link from "next/link";
import { Title } from "@components/ui/Title";
import { ROUTES } from "@root/routes";

interface Props extends PostCategoriesQueryVariables {
  title?: string;
  data?: PostCategoriesQuery;
}

const PostAllCategoriesBlock: FC<Props> = ({ title, data }) => {
  // Filter categories that have more than 0 posts
  // If data or postCategories is null/undefined, return an empty array
  const posts = data?.postCategories?.edges
    ? data.postCategories.edges.filter(
        (category) => category.node.countPosts > 0
      )
    : [];

  // If there are no categories with posts, return null (no rendering of this block)
  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <div className="mt-10">
      {title && (
        <Title as="h2" size="md" divider>
          {title}
        </Title>
      )}

      <div className="flex flex-wrap w-auto">
        {posts &&
          posts.map((item, key) => (
            <p
              key={key}
              className="my-2 mr-4 h-8 border border-gray-200 bg-white text-gwg_dull_gray rounded-2xl px-3 py-2 text-xs"
            >
              <Link
                href={ROUTES.blog.category(item.node.slug)}
                title={t({
                  id: "common.link.title",
                  message: "GoWithGuide - Private Tours & Local Tour Guides",
                })}
                className="hover:underline text-gray-600"
              >
                {item.node.name}
              </Link>
            </p>
          ))}
      </div>
    </div>
  );
};
export default PostAllCategoriesBlock;
